import { UIElementProps } from 'types/prop-types';

import IconUau from 'assets/img/moedas/uau-new.png';
import IconMandou from 'assets/img/moedas/mandou.svg';
import IconValeu from 'assets/img/moedas/valeu.svg';

import IconColaboracao from 'assets/img/comportamento/colaboracao-new.png';
import IconInovacao from 'assets/img/comportamento/inovacao-new.png';
import IconFoco from 'assets/img/comportamento/foco-new.png';
import IconResolutividade from 'assets/img/comportamento/resolutividade-new.png';
import IconLideranca from 'assets/img/comportamento/lideranca-new.png';

import IconSeloColaboracao2022 from 'assets/img/comportamento/selo-colaboracao-2022.png';
import IconSeloInovacao2022 from 'assets/img/comportamento/selo-inovacao-2022.png';
import IconSeloFoco2022 from 'assets/img/comportamento/selo-foco-2022.png';
import IconSeloResolutividade2022 from 'assets/img/comportamento/selo-resolutividade-2022.png';

import IconSeloColaboracao1S2023 from 'assets/img/comportamento/selo-colaboracao-1S2023.svg';
import IconSeloInovacao1S2023 from 'assets/img/comportamento/selo-inovacao-1S2023.svg';
import IconSeloFoco1S2023 from 'assets/img/comportamento/selo-foco-1S2023.svg';
import IconSeloResolutividade1S2023 from 'assets/img/comportamento/selo-resolutividade-1S2023.svg';

import IconSeloColaboracao2S2023 from 'assets/img/comportamento/selo-colaboracao-2S2023.png';
import IconSeloInovacao2S2023 from 'assets/img/comportamento/selo-inovacao-2S2023.png';
import IconSeloFoco2S2023 from 'assets/img/comportamento/selo-foco-2S2023.png';
import IconSeloResolutividade2S2023 from 'assets/img/comportamento/selo-resolutividade-2S2023.png';
import IconSeloLideranca2S2023 from 'assets/img/comportamento/selo-lideranca-2S2023.png';

import IconSeloColaboracao1S2024 from 'assets/img/comportamento/selo-colaboracao-1S2024.png';
import IconSeloInovacao1S2024 from 'assets/img/comportamento/selo-inovacao-1S2024.png';
import IconSeloFoco1S2024 from 'assets/img/comportamento/selo-foco-1S2024.png';
import IconSeloResolutividade1S2024 from 'assets/img/comportamento/selo-resolutividade-1S2024.png';
import IconSeloLideranca1S2024 from 'assets/img/comportamento/selo-lideranca-1S2024.png';

import IconSeloColaboracao2S2024 from 'assets/img/comportamento/selo-colaboracao-2S2024.png';
import IconSeloInovacao2S2024 from 'assets/img/comportamento/selo-inovacao-2S2024.png';
import IconSeloFoco2S2024 from 'assets/img/comportamento/selo-foco-2S2024.png';
import IconSeloResolutividade2S2024 from 'assets/img/comportamento/selo-resolutividade-2S2024.png';
import IconSeloLideranca2S2024 from 'assets/img/comportamento/selo-lideranca-2S2024.png';

import IconSeloColaboracao1S2025 from 'assets/img/comportamento/selo-colaboracao-1S2025.png';
import IconSeloInovacao1S2025 from 'assets/img/comportamento/selo-inovacao-1S2025.png';
import IconSeloFoco1S2025 from 'assets/img/comportamento/selo-foco-1S2025.png';
import IconSeloResolutividade1S2025 from 'assets/img/comportamento/selo-resolutividade-1S2025.png';
import IconSeloLideranca1S2025 from 'assets/img/comportamento/selo-lideranca-1S2025.png';

import IconSeloColaboracao2S2025 from 'assets/img/comportamento/selo-colaboracao-2S2025.png';
import IconSeloInovacao2S2025 from 'assets/img/comportamento/selo-inovacao-2S2025.png';
import IconSeloFoco2S2025 from 'assets/img/comportamento/selo-foco-2S2025.png';
import IconSeloResolutividade2S2025 from 'assets/img/comportamento/selo-resolutividade-2S2025.png';
import IconSeloLideranca2S2025 from 'assets/img/comportamento/selo-lideranca-2S2025.png';


import IconSeloRealizacao2S2023 from 'assets/img/comportamento/selo-realizacao-2S2023.png';
import IconSeloGaleria2S2023 from 'assets/img/comportamento/selo-galeria-reconhecimento-2S2023.png';

import IconSeloRealizacao1S2023 from 'assets/img/comportamento/selo-realizacao-1S2023.svg';
import IconSeloGaleria1S2023 from 'assets/img/comportamento/selo-galeria-reconhecimento-1S2023.png';

import IconSeloRealizacao1S2024 from 'assets/img/comportamento/selo-realizacao-1S2024.png';
import IconSeloGaleria1S2024 from 'assets/img/comportamento/selo-galeria-reconhecimento-1S2024.png';

import IconSeloRealizacao2S2024 from 'assets/img/comportamento/selo-realizacao-2S2024.png';
import IconSeloGaleria2S2024 from 'assets/img/comportamento/selo-galeria-reconhecimento-2S2024.png';

import IconSeloRealizacao1S2025 from 'assets/img/comportamento/selo-realizacao-1S2025.png';
import IconSeloGaleria1S2025 from 'assets/img/comportamento/selo-galeria-reconhecimento-1S2025.png';

import IconSeloRealizacao2S2025 from 'assets/img/comportamento/selo-realizacao-2S2025.png';
import IconSeloGaleria2S2025 from 'assets/img/comportamento/selo-galeria-reconhecimento-2S2025.png';

import IconSeloColaboracao1S2026 from 'assets/img/comportamento/selo-colaboracao-1S2026.png';
import IconSeloInovacao1S2026 from 'assets/img/comportamento/selo-inovacao-1S2026.png';
import IconSeloFoco1S2026 from 'assets/img/comportamento/selo-foco-1S2026.png';
import IconSeloResolutividade1S2026 from 'assets/img/comportamento/selo-resolutividade-1S2026.png';
import IconSeloLideranca1S2026 from 'assets/img/comportamento/selo-lideranca-1S2026.png';
import IconSeloRealizacao1S2026 from 'assets/img/comportamento/selo-realizacao-1S2026.png';
import IconSeloGaleria1S2026 from 'assets/img/comportamento/selo-galeria-reconhecimento-1S2026.png';

type IconProps = UIElementProps & {
  size?: any;
  year?: number;
  cycle?: string;
  selo?: string;
};

const icons: any = {
  SeloColaboracao1S2023: IconSeloColaboracao1S2023,
  SeloColaboracao2S2023: IconSeloColaboracao2S2023,
  SeloColaboracao1S2024: IconSeloColaboracao1S2024,
  SeloColaboracao2S2024: IconSeloColaboracao2S2024,
  SeloColaboracao1S2025: IconSeloColaboracao1S2025,
  SeloColaboracao2S2025: IconSeloColaboracao2S2025,
  SeloColaboracao1S2026: IconSeloColaboracao1S2026,
  SeloInovacao1S2023: IconSeloInovacao1S2023,
  SeloInovacao2S2023: IconSeloInovacao2S2023,
  SeloInovacao1S2024: IconSeloInovacao1S2024,
  SeloInovacao2S2024: IconSeloInovacao2S2024,
  SeloInovacao1S2025: IconSeloInovacao1S2025,
  SeloInovacao2S2025: IconSeloInovacao2S2025,
  SeloInovacao1S2026: IconSeloInovacao1S2026,
  SeloFoco1S2023: IconSeloFoco1S2023,
  SeloFoco2S2023: IconSeloFoco2S2023,
  SeloFoco1S2024: IconSeloFoco1S2024,
  SeloFoco2S2024: IconSeloFoco2S2024,
  SeloFoco1S2025: IconSeloFoco1S2025,
  SeloFoco2S2025: IconSeloFoco2S2025,
  SeloFoco1S2026: IconSeloFoco1S2026,
  SeloResolutividade1S2023: IconSeloResolutividade1S2023,
  SeloResolutividade2S2023: IconSeloResolutividade2S2023,
  SeloResolutividade1S2024: IconSeloResolutividade1S2024,
  SeloResolutividade2S2024: IconSeloResolutividade2S2024,
  SeloResolutividade1S2025: IconSeloResolutividade1S2025,
  SeloResolutividade2S2025: IconSeloResolutividade2S2025,
  SeloResolutividade1S2026: IconSeloResolutividade1S2026,
  SeloLideranca2S2023: IconSeloLideranca2S2023,
  SeloLideranca1S2024: IconSeloLideranca1S2024,
  SeloLideranca2S2024: IconSeloLideranca2S2024,
  SeloLideranca1S2025: IconSeloLideranca1S2025,
  SeloLideranca2S2025: IconSeloLideranca2S2025,
  SeloLideranca1S2026: IconSeloLideranca1S2026,
  SeloRealizacao1S2023: IconSeloRealizacao1S2023,
  SeloRealizacao2S2023: IconSeloRealizacao2S2023,
  SeloRealizacao1S2024: IconSeloRealizacao1S2024,
  SeloRealizacao2S2024: IconSeloRealizacao2S2024,
  SeloRealizacao1S2025: IconSeloRealizacao1S2025,
  SeloRealizacao2S2025: IconSeloRealizacao2S2025,
  SeloRealizacao1S2026: IconSeloRealizacao1S2026,
  SeloGaleria1S2023: IconSeloGaleria1S2023,
  SeloGaleria2S2023: IconSeloGaleria2S2023,
  SeloGaleria1S2024: IconSeloGaleria1S2024,
  SeloGaleria2S2024: IconSeloGaleria2S2024,
  SeloGaleria1S2025: IconSeloGaleria1S2025,
  SeloGaleria2S2025: IconSeloGaleria2S2025,
  SeloGaleria1S2026: IconSeloGaleria1S2026
};

export function Uau(props: IconProps) {
  return (
    <div>
      <img src={IconUau} alt="" style={{ height: props?.size || 32 }} />
    </div>
  );
}

export function MandouBem(props: IconProps) {
  return (
    <div>
      <img src={IconMandou} alt="" style={{ height: props?.size || 32 }} />
    </div>
  );
}

export function Valeu(props: IconProps) {
  return (
    <div>
      <img src={IconValeu} alt="" style={{ height: props?.size || 32 }} />
    </div>
  );
}

export function Colaboracao(props: IconProps) {
  return (
    <div>
      <img src={IconColaboracao} alt="" style={{ height: props?.size || 32 }} />
    </div>
  );
}

export function Inovacao(props: IconProps) {
  return (
    <div>
      <img src={IconInovacao} alt="" style={{ height: props?.size || 32 }} />
    </div>
  );
}

export function FocoNoCliente(props: IconProps) {
  return (
    <div>
      <img src={IconFoco} alt="" style={{ height: props?.size || 32 }} />
    </div>
  );
}

export function Resolutividade(props: IconProps) {
  return (
    <div>
      <img src={IconResolutividade} alt="" className={`w-auto h-full object-contain`} style={{ height: props?.size || 32 }} />
    </div>
  );
}

export function Lideranca(props: IconProps) {
  return (
    <div>
      <img src={IconLideranca} alt="" className={`w-auto h-full object-contain`} style={{ height: props?.size || 32 }} />
    </div>
  );
}

/** Arte do selo de um ciclo (`selo` como em `<Selo>`: Colaboracao, Galeria, Realizacao…), ou `undefined` sem arte. */
export function urlDoSelo(selo: string, ciclo: string): string | undefined {
  return icons[`Selo${selo}${ciclo}`];
}

export function Selo({ size, selo, cycle = '1S2023' }: IconProps) {
  return icons[`Selo${selo}${cycle}`] ? (
    <div>
      <img
        className="object-contain"
        src={icons[`Selo${selo}${cycle}`]}
        alt={`"Destaque em ${selo}"`}
        style={{ height: size || 32 }}
      />
    </div>
  ) : (
    <></>
  );
}

export function SeloInovacao(props: IconProps) {
  return (
    <div>
      <img
        src={typeof props.year === 'number' && props.year === 2023 ? IconSeloInovacao1S2023 : IconSeloInovacao1S2023}
        alt="Destaque em Inovação"
        style={{ height: props?.size || 32 }}
      />
    </div>
  );
}

export function SeloColaboracao(props: IconProps) {
  return (
    <div>
      <img
        src={typeof props.year === 'number' && props.year === 2023 ? IconSeloInovacao1S2023 : IconSeloInovacao1S2023}
        alt="Destaque em Inovação"
        style={{ height: props?.size || 32 }}
      />
    </div>
  );
}

export function SeloFocoNoCliente(props: IconProps) {
  return (
    <div>
      <img
        src={typeof props.year === 'number' && props.year === 2023 ? IconSeloFoco1S2023 : IconSeloFoco1S2023}
        alt="Destaque em Foco no Cliente"
        style={{ height: props?.size || 32 }}
      />
    </div>
  );
}

export function SeloResolutividade(props: IconProps) {
  return (
    <div>
      <img
        src={typeof props.year === 'number' && props.year === 2023 ? IconSeloResolutividade1S2023 : IconSeloResolutividade1S2023}
        alt="Destaque em Protagonismo"
        style={{ height: props?.size || 32 }}
      />
    </div>
  );
}

export function SeloLideranca(props: IconProps) {
  return (
    <div>
      <img src={IconSeloResolutividade1S2023} alt="Destaque em Liderança" style={{ height: props?.size || 32 }} />
    </div>
  );
}

export function SeloGaleria(props: IconProps) {
  const cycle = props?.cycle || '1S2023';
  const icon = icons[`SeloGaleria${cycle}`] || icons.SeloGaleria1S2023;

  return (
    <div>
      <img src={icon} alt="Galeria do Reconhecimento" style={{ height: props?.size || 32 }} />
    </div>
  );
}

export function SeloRealizacao(props: IconProps) {
  return (
    <div>
      <img src={icons[`SeloRealizacao${props?.cycle}`]} alt="Selo Realização Destaque" style={{ height: props?.size || 32 }} />
    </div>
  );
}
